import React from "react";
import PlacementSection from "../../components/StudentWorld/Placement.tsx";
import MetaComponent from "../../components/CommonComponents/MetaComponent.tsx";
const StudentPlacement: React.FC = () => {
  return (
    <div>
      <MetaComponent
        title="Placements at Aptech Limited."
        desc="Transform your career with Aptech's vocational training programs. Benefit from workshops, mock interviews, and placement support with top recruiters like Amazon, Indigo, and VLCC."
        keywords="vocational training programs, placement support, career development, Placements at Aptech "
      />
      <PlacementSection />
    </div>
  );
}

export default StudentPlacement;
